export default __webpack_public_path__ + "guide--raster-cyclone-debbie-480-636e110faedcf5f745e1c761140bd0af.jpg";